import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';

import { TrackerComponent } from '@shared/components/tracker/tracker.component';
import { Router } from '@angular/router';

@Component({
  selector: 'lt-home',
  imports: [TrackerComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  private router = inject(Router);

  trackingNumbers = signal<string[] | null>(null);
  customerReference = signal<string | null>(null);

  constructor() {
    effect(() => {
      if (this.trackingNumbers() && this.trackingNumbers()!.length > 0) {
        const customerRef = this.customerReference();
        this.router.navigate(['track'], {
          queryParams: {
            trackingNumber: this.trackingNumbers(),
            ...(customerRef && { customerRef }),
          },
        });
      }
    });
  }
}
